import { commonDeDe } from './locales/de-DE/common';
import { featuresDeDe } from './locales/de-DE/features';
import { commonEnGb } from './locales/en-GB/common';
import { featuresEnGb } from './locales/en-GB/features';
import { commonEsEs } from './locales/es-ES/common';
import { featuresEsEs } from './locales/es-ES/features';
import { commonItIt } from './locales/it-IT/common';
import { featuresItIt } from './locales/it-IT/features';
import { commonPlPl } from './locales/pl-PL/common';
import { featuresPlPl } from './locales/pl-PL/features';
import { commonRoRo } from './locales/ro-RO/common';
import { featuresRoRo } from './locales/ro-RO/features';
import { commonSrRs } from './locales/sr-RS/common';
import { featuresSrRs } from './locales/sr-RS/features';
import type { I18nResources } from './types';

declare global {
  interface I18nNamespaceRegistry {
    common: typeof commonEnGb;
    features: typeof featuresEnGb;
  }
}

export const platformI18nResources: I18nResources<'common' | 'features'> = {
  'de-DE': {
    common: commonDeDe,
    features: featuresDeDe,
  },
  'en-GB': {
    common: commonEnGb,
    features: featuresEnGb,
  },
  'es-ES': {
    common: commonEsEs,
    features: featuresEsEs,
  },
  'it-IT': {
    common: commonItIt,
    features: featuresItIt,
  },
  'pl-PL': {
    common: commonPlPl,
    features: featuresPlPl,
  },
  'ro-RO': {
    common: commonRoRo,
    features: featuresRoRo,
  },
  'sr-RS': {
    common: commonSrRs,
    features: featuresSrRs,
  },
};
